import React from "react";
import agileIcon from "../../../images/icons/icons8-g.png";
import teamIcon from "../../../images/icons/icons8-team.png";
import comparingIcon from "../../../images/icons/icons-comparing.png";
import ambitionsIcon from "../../../images/icons/icons8-ambitios.png";
// import artistIcon from "../../../images/icons/icons8-artist.png";
import frendly from "../../../images/icons/icons-friendly.png";

export const SoftSkills = () => {
  return (
    <>
      <div className="soft-skills">
        <h1>Особисті якості</h1>
        <ul className="skills-list">
          <li>
            <img className="skills-icon" src={agileIcon} alt="html-icon" />
            <p>Гнучка в плані спілкування</p>
          </li>
          <li>
            <img className="skills-icon" src={teamIcon} alt="team-icon" />
            <p>Командний гравець</p>
          </li>
          <li>
            <img
              className="skills-icon"
              src={comparingIcon}
              alt="compare-icon"
            />
            <p>Люблю вирішувати задачі</p>
          </li>
          <li>
            <img
              className="skills-icon"
              src={ambitionsIcon}
              alt="ambitions-icon"
            />
            <p>Цілеспрямована</p>
          </li>
          {/* <li>
            <img className="skills-icon" src={artistIcon} alt="artist-icon" />
            <p>Код свого роду мистецтво)</p>
          </li> */}
          <li>
            <img className="skills-icon" src={frendly} alt="frendly-icon" />
            <p> Дружня</p>
          </li>
        </ul>
      </div>
    </>
  );
};
